<template>
  <div class="home">
    <header-com></header-com>
    <div class="main">
      <div class="cont bs">
        <h3 class="title">logo上传</h3>
        <div class="wrap">
          <el-form ref="formInline" :model="formInline" label-width="120px">
            <el-form-item label="网站logo：" style="width: 100%">
              <el-upload
                action="https://jsonplaceholder.typicode.com/posts/"
                list-type="picture-card"
                :on-preview="handlePictureCardPreview"
                :on-remove="handleRemove"
                v-model="formInline.photo"
              >
                <i class="el-icon-plus"></i>
                <div slot="tip" class="el-upload__tip">请上传jpg, gif, png格式的图片。logo 图片尺寸建议不超过250×50px。图片大小建议不超过2MB。该logo显示在前台顶部导航左侧。</div>
              </el-upload>
              <el-dialog :visible.sync="dialogVisible">
                <img width="100%" :src="dialogImageUrl" alt />
              </el-dialog>
            </el-form-item>
            <el-form-item label="浏览器图标：" style="width: 100%">
              <el-upload
                action="https://jsonplaceholder.typicode.com/posts/"
                list-type="picture-card"
                :on-preview="handlePictureCardPreview"
                :on-remove="handleRemove"
                v-model="formInline.photo"
              >
                <i class="el-icon-plus"></i>
                <div slot="tip" class="el-upload__tip">请上传ico格式的图标文件, 建议尺寸为 16×16px 或 32×32px。图片大小建议不超过2MB。</div>
              </el-upload>
              <el-dialog :visible.sync="dialogVisible">
                <img width="100%" :src="dialogImageUrl" alt />
              </el-dialog>
            </el-form-item>
            <el-form-item class="btns">
              <el-button type="primary" @click="onSubmit">提交</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderCom from "../components/Header.vue";
export default {
  name: "upload",
  data() {
    return {
      dialogImageUrl: "",
      dialogVisible: false,
      formInline: {
        name: "",
        photo: ''
      }
    };
  },
  components: {
    HeaderCom
  },
  methods: {
    onSubmit() {
      console.log("submit!");
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    }
  }
};
</script>
<style lang="less" scoped>
.cont {
  width: 1200px;
  margin: 30px auto;
  .wrap {
    padding: 20px;
  }
  .title {
    font-size: 18px;
    line-height: 40px;
    border-bottom: 1px solid #ddd;
    padding: 0 20px;
    font-weight: normal;
  }
  .btns{
    text-align: center;
    /deep/.el-form-item__content{
      margin-left: 0 !important;
    }
  }
}
</style>
